import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { fetchContactsInfo } from "./asyncThunk";
import { IContactsReduxState, IContactsInfoResponse } from "./type";

const initialState: IContactsReduxState = {
  isLoading: false,
  contactsInfo: {
    address: "",
    phone: "",
    email: "",
    messenger_1: "",
    messenger_2: "",
    website: "",
  },
};

const contactsSlice = createSlice({
  name: "contacts",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchContactsInfo.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchContactsInfo.fulfilled, (state, action: PayloadAction<IContactsInfoResponse[]>) => {
        const contactsInfo = action.payload[0];

        state.contactsInfo = {
          address: contactsInfo.address,
          phone: contactsInfo.phone_number,
          email: contactsInfo.email,
          messenger_1: contactsInfo.messanger_1,
          messenger_2: contactsInfo.messanger_2,
          website: contactsInfo.website,
        };
        state.isLoading = false;
      })
      .addCase(fetchContactsInfo.rejected, (state) => {
        state.isLoading = false;
      })
  }
});

export default contactsSlice.reducer;